/* Colunas do quadro e estados de documentação. */
export const ETAPAS=[{id:"aberto",nome:"Abertos",cor:"var(--aberto)"},{id:"doc",nome:"Documentos",cor:"var(--doc)"},
 {id:"proto",nome:"Protocolado",cor:"var(--proto)"},{id:"exig",nome:"Em exigência",cor:"var(--exig)"},
 {id:"conc",nome:"Concluído",cor:"var(--conc)"}];

/* As cores saem das variaveis: escritas na mao, o pontinho do cartao ficava
   com o ambar antigo enquanto o titulo da coluna ja usava o novo. */
export const DOCS={nao:{rot:"Doc não enviado",cor:"var(--exig)"},parcial:{rot:"Doc parcial",cor:"var(--doc)"},sim:{rot:"Doc enviado",cor:"var(--conc)"}};
